// import {
//   AppBar,
//   Box,
//   Button,
//   createTheme,
//   Dialog,
  
//   Grid,
//   IconButton,
//   ListItemText,
//   Menu,
//   MenuItem,
//   Slide,
//   Stack,
//   TextField,
//   ThemeProvider,
//   Toolbar,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import EditNoteIcon from "@mui/icons-material/EditNote";
// import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
// import CloseIcon from "@mui/icons-material/Close";
// import { membershipApis } from "../../../Data/axios";
// import MUIDataTable from "mui-datatables";
// import Paper from "@mui/material/Paper";
// import { styled } from "@mui/material/styles";
// import Switch from "@mui/material/Switch";
// import { getUserInfo } from "../../../Data/UserData";
// import StatusAlert from "../../../StatusAlertList/StatusAlert";
// const ViewMoreKnowledge = () => {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [openMenuId, setOpenMenuId] = useState(null);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [openButton, setOpenButton] = React.useState(false);
//   const openDropMenu = Boolean(anchorEl);
//   const [alertOpen, setAlertOpen] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [alertSeverity, setAlertSeverity] = useState("info");
//   const [data, setData] = useState([]);
//   const [updateDetails, setUpdateDetails] = React.useState("");
//   const [updateStatus, setUpdateStatus] = React.useState("");
//   const { id: openMenuIdNew } = useParams();
//   const handleClick = (event) => {
//     setAnchorEl(event.currentTarget);
//   };
//   const handleCloseMenu = () => {
//     setAnchorEl(null);
//   };
//   const [detailValue, setDetailValue] = useState([]);
//   // const location = useLocation();
//   // const openMenuIdNew = location.state;

//   // console.log(openMenuIdNew, id, "openmenuid got");
//   useEffect(() => {
//     getDataPass();
//   }, [openMenuIdNew]);
//   const getDataPass = async () => {
//     const rowData = await membershipApis.membershipViewMoreId(openMenuIdNew);
//     console.log(rowData, "membership view more got");
//     setDetailValue(rowData);
//   };
//   // const [switchState, setSwitchState] = useState(
//   //   detailValue.reduce((acc, row) => {
//   //     acc[row.id] = row.status === "1"; // Initialize state based on the data
//   //     return acc;
//   //   }, {})
//   // );
//   console.log(detailValue, "detailValue got ");

//   const handleSwitchChange = (userId) => (event) => {
//     const newValue = event.target.checked;
//     // setSwitchState((prevState) => ({
//     //   ...prevState,
//     //   [userId]: newValue,
//     // }));

//     // Update the original data with the new value ("1" or "0")
//     setDetailValue((prevData) =>
//       prevData.map((row) =>
//         row.id === userId ? { ...row, status: newValue ? "1" : "0" } : row
//       )
//     );

//     console.log(`Row ${userId} updated status to: ${newValue ? "1" : "0"}`);
//     // You can also perform an API call here if needed
//   };
//   // const [switchValues, setSwitchValues] = useState({});

//   // const handleSwitchChange = (event, rowId) => {
//   //   const newStatus = event.target.checked ? 1 : 0;
//   //   setSwitchValues((prevState) => ({
//   //     ...prevState,
//   //     [rowId]: newStatus,
//   //   }));
//   // };
//   const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
//   });
//   const Item = styled(Paper)(({ theme }) => ({
//     backgroundColor: "#899",
//     color: "#000",

//     ...theme.typography.body2,
//     padding: theme.spacing(1),
//     cursor: "pointer",
//     textAlign: "center",
//     ...theme.applyStyles("dark", {
//       backgroundColor: "#899",
//       color: "#000",
//     }),
//   }));

//   const handleOpenMenu = (id) => {
//     setOpenMenuId(id);
//   };
//   const showAlert = (message, severity) => {
//     setAlertMessage(message);
//     setAlertSeverity(severity);
//     setAlertOpen(true);
//   };
//   const handleUpdateButton = () => {
//     setOpenButton(true);
//   };
//   const handleCloseButton = () => {
//     setOpenButton(false);
//   };
//   async function handleEdit() {
//     let result = await fetch(
//       "https://rptpl.roadpilot.co.in/public/api/getMembershiplist/" + openMenuId
//     );
//     const resultNew = await result.json();

//     setData(resultNew);
//     handleUpdateButton();
//   }
//   useEffect(() => {
//     setUpdateDetails(data.text);
//   }, [data.text]);

//   useEffect(() => {
//     setUpdateStatus(data.status);
//   }, [data.status]);
//   async function UpdateData() {
//     const formData = new FormData();
//     formData.append("text", updateDetails);
//     formData.append("status", updateStatus);
//     formData.append("membership_id", openMenuIdNew);
//     formData.append("created_by", getUserInfo());

//     try {
//       let response = await fetch(
//         `https://rptpl.roadpilot.co.in/public/api/updateMembershiplist/${data.id}`,
//         {
//           method: "POST",
//           body: formData,
//         }
//       );
//       if (!response.ok) {
//         throw new Error("Failed to update data");
//       }
//       showAlert(" updated successfully", "success");
//       handleCloseButton();
//       getDataPass();
//     } catch (error) {
//       console.error(error);
//       showAlert("Failed to update business location", "error");
//     }
//   }
//   const columns = [
//     // {
//     //   name: "jobspost",
//     //   label: "Details",
//     //   options: {
//     //     customHeadRender: ({ index }) => {
//     //       return (
//     //         <th
//     //           key={index}
//     //           style={{
//     //             textAlign: "center",
//     //             borderBottom: "1px solid #ddd",
//     //           }}
//     //         >
//     //           Details
//     //         </th>
//     //       );
//     //     },
//     //     customBodyRender: (value) => {
//     //       return (
//     //         <div
//     //           key={value}
//     //           style={{
//     //             display: "flex",
//     //             justifyContent: "center",
//     //             alignItems: "center",
//     //           }}
//     //         >
//     //           {value || " "}
//     //         </div>
//     //       );
//     //     },
//     //   },
//     // },
//     // {
//     //   name: "",
//     //   label: "Status",
//     //   options: {
//     //     customHeadRender: ({ index }) => {
//     //       return (
//     //         <th
//     //           key={index}
//     //           style={{
//     //             textAlign: "center",
//     //             borderBottom: "1px solid #ddd",
//     //           }}
//     //         >
//     //           Status
//     //         </th>
//     //       );
//     //     },
//     //     customBodyRender: (value, tableMeta, index) => {
//     //       const rowId = tableMeta.rowData[2];
//     //       return (
//     //         <div
//     //           key={index}
//     //           style={{
//     //             display: "flex",
//     //             justifyContent: "center",
//     //             alignItems: "center",
//     //           }}
//     //         >
//     //           <Switch
//     //           // checked={switchState[rowId] || false}
//     //           // onChange={handleSwitchChange(rowId)}
//     //           // inputProps={{ "aria-label": `Switch for row ${rowId}` }}
//     //           />
//     //         </div>
//     //       );
//     //       // return (
//     //       //   <div
//     //       //     key={index}
//     //       //     style={{
//     //       //       display: "flex",
//     //       //       justifyContent: "center",
//     //       //       alignItems: "center",
//     //       //     }}
//     //       //   >
//     //       //     <Select
//     //       //       value={value}
//     //       //       // onChange={(event) => handleChangeSelected(event, value.id)}
//     //       //       displayEmpty
//     //       //       renderValue={(selected) => {
//     //       //         if (selected === "1") {
//     //       //           return (
//     //       //             <MenuItem sx={{ display: "flex", alignItems: "center" }}>
//     //       //               Active
//     //       //             </MenuItem>
//     //       //           ); // Placeholder text
//     //       //         }
//     //       //         if (selected === "0") {
//     //       //           return (
//     //       //             <MenuItem sx={{ display: "flex", alignItems: "center" }}>
//     //       //               Relieve
//     //       //             </MenuItem>
//     //       //           ); // Placeholder text
//     //       //         }
//     //       //         if (selected === "2") {
//     //       //           return (
//     //       //             <MenuItem sx={{ display: "flex", alignItems: "center" }}>
//     //       //               Leave
//     //       //             </MenuItem>
//     //       //           ); // Placeholder text
//     //       //         }
//     //       //         return selected; // Show selected value
//     //       //       }}
//     //       //       sx={{
//     //       //         width: "110px",
//     //       //         border: "none",
//     //       //         color: "#000 ",
//     //       //         bgcolor: "#fff",
//     //       //         "& .MuiSelect-select": {
//     //       //           padding: 0,
//     //       //         },
//     //       //       }}
//     //       //     >
//     //       //       <MenuItem
//     //       //         value={1}
//     //       //         sx={{ display: "flex", alignItems: "center" }}
//     //       //       >
//     //       //         Active
//     //       //       </MenuItem>
//     //       //       <MenuItem
//     //       //         value={0}
//     //       //         sx={{ display: "flex", alignItems: "center" }}
//     //       //       >
//     //       //         Relieve
//     //       //       </MenuItem>
//     //       //       <MenuItem
//     //       //         value={2}
//     //       //         sx={{ display: "flex", alignItems: "center" }}
//     //       //       >
//     //       //         Leave
//     //       //       </MenuItem>
//     //       //     </Select>
//     //       //   </div>
//     //       // );
//     //       //  <Switch
//     //       //       checked={switchValues[rowId] === 1 || value === 1} // Use the state for this row or the original value
//     //       //       onChange={(event) => handleSwitchChange(event, rowId)}
//     //       //       color="primary"
//     //       //       inputProps={{ "aria-label": "controlled" }}
//     //       //     />
//     //     },
//     //   },
//     // },
//     // {
//     //   name: "id",
//     //   label: "Action",
//     //   options: {
//     //     customHeadRender: ({ index }) => {
//     //       return (
//     //         <th
//     //           key={index}
//     //           style={{
//     //             textAlign: "right",
//     //             paddingRight: "70px",
//     //             borderBottom: "1px solid #ddd",
//     //           }}
//     //         >
//     //           Action
//     //         </th>
//     //       );
//     //     },
//     //     customBodyRender: (value, tableMeta) => (
//     //       <>
//     //         <div
//     //           key={value}
//     //           style={{
//     //             display: "flex",
//     //             justifyContent: "flex-end", // Aligns content to the left
//     //             alignItems: "center",
//     //             paddingRight: "20px", // Add padding for starting point
//     //           }}
//     //         >
//     //           <div style={{ paddingRight: "20px" }}>
//     //             <Button
//     //               id="basic-button"
//     //               aria-controls={openDropMenu ? "basic-menu" : undefined}
//     //               aria-haspopup="true"
//     //               aria-expanded={openDropMenu ? "true" : undefined}
//     //               onClick={handleClick}
//     //             >
//     //               <div onClick={() => handleOpenMenu(value)}>
//     //                 <MoreHorizTwoToneIcon />
//     //               </div>
//     //             </Button>
//     //             <Menu
//     //               id="basic-menu"
//     //               anchorEl={anchorEl}
//     //               open={openDropMenu}
//     //               onClose={handleCloseMenu}
//     //               MenuListProps={{
//     //                 "aria-labelledby": "basic-button",
//     //               }}
//     //             >
//     //               <MenuItem onClick={handleCloseMenu}>
//     //                 <div
//     //                   onClick={() => handleEdit()}
//     //                   style={{
//     //                     display: "flex",
//     //                     justifyContent: "space-center",
//     //                     alignItems: "center",
//     //                   }}
//     //                 >
//     //                   <EditNoteIcon /> Edit
//     //                 </div>
//     //               </MenuItem>
//     //             </Menu>
//     //           </div>
//     //         </div>
//     //       </>
//     //     ),
//     //   },
//     // },
//   ];
//   const options = {
//     selectableRows: "none",
//     selectToolbarPlacement: "none",
//     elevation: 0,
//     rowsPerPage: rowsPerPage,
//     rowsPerPageOptions: [5, 10, 25, 100],
//     onChangeRowsPerPage: (newRowsPerPage) => {
//       setRowsPerPage(newRowsPerPage);
//     },
//     tableBody: {
//       style: {
//         maxHeight: `${rowsPerPage * 50}px`,
//         overflow: "auto",
//         marginLeft: "5px",
//         transform: "translateZ(0)",
//         backfaceVisibility: "hidden",
//         boxShadow: "none",
//       },
//     },
//     tableHead: {
//       style: {
//         backgroundColor: "#f2f2f2",
//         color: "black",
//       },
//     },
//     rows: {
//       style: {},
//       selectableRowsOnClick: true,
//     },
//   };

//   const getTheme = () =>
//     createTheme({
//       palette: {
//         mode: "light",
//         primary: {
//           main: "#2196f3",
//         },
//         secondary: {
//           main: "#03a9f4",
//         },
//       },
//       typography: {
//         fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
//       },
//       components: {
//         MuiButton: {
//           styleOverrides: {
//             root: {
//               textTransform: "none",
//             },
//           },
//         },
//       },
//       tableBody: {
//         style: {
//           maxHeight: "500px",
//           overflowY: "scroll",
//         },
//       },
//       tableHead: {
//         style: {
//           backgroundColor: "#f2f2f2",
//           color: "black",
//         },
//       },
//       rows: {
//         style: {
//           "&:hover": {
//             backgroundColor: "#f2f2f2",
//           },
//         },
//       },
//     });
//   return (
//     <>
//       <StatusAlert
//         open={alertOpen}
//         setOpen={setAlertOpen}
//         message={alertMessage}
//         severity={alertSeverity}
//       />
//       <Dialog
//         fullWidth
//         maxWidth="md"
//         open={openButton}
//         onClose={handleCloseButton}
//         TransitionComponent={Transition}
//         PaperProps={{
//           style: {
//             position: "absolute",
//             background: "#141b2d",
//             top: "0",
//             backgroundColor: "white",
//             maxHeight: "95%",
//             margin: "auto",
//             overflowX: "hidden",
//             zIndex: 1200,
//           },
//         }}
//       >
//         <AppBar sx={{ position: "relative" }}>
//           <Toolbar>
//             <IconButton
//               edge="start"
//               color="inherit"
//               onClick={handleCloseButton}
//               aria-label="close"
//             >
//               <CloseIcon />
//             </IconButton>
//             <Typography sx={{ ml: 2, flex: 1 }} component="div">
//               Update Membership Details
//             </Typography>
//           </Toolbar>
//         </AppBar>

//         <Box sx={{ background: "#fff" }}>
//           <Grid
//             container
//             spacing={2}
//             style={{ color: "black", margin: "10px" }}
//           >
//             <Grid item xs={11} sm={10} md={10}>
//               <Stack direction="column" spacing={2}>
//                 <Typography variant="p" gutterBottom style={{ color: "black" }}>
//                   Detail
//                 </Typography>
//                 <TextField
//                   value={updateDetails}
//                   onChange={(e) => setUpdateDetails(e.target.value)}
//                   fullWidth
//                   placeholder="eg.abc"
//                   type="text"
//                   inputProps={{ style: { color: "black" } }}
//                   InputLabelProps={{ style: { color: "black" } }}
//                   sx={{
//                     border: "1px solid black",
//                     borderRadius: "5px",
//                     "& .MuiOutlinedInput-root": {
//                       borderColor: "black",
//                       "&:hover fieldset": {
//                         borderColor: "black",
//                       },
//                       "&.Mui-focused fieldset": {
//                         borderColor: "black",
//                       },
//                     },
//                     "& .MuiOutlinedInput-input": {
//                       "&::placeholder": { color: "gray" },
//                     },
//                   }}
//                 />
//               </Stack>
//             </Grid>
//           </Grid>
//           <Grid container sx={{ padding: "0 0 20px 20px" }}>
//             <Grid item xs={11} className="messageFooter">
//               <Box className="response" onClick={UpdateData}>
//                 Update
//               </Box>
//               <Box className="cancel" onClick={handleCloseButton}>
//                 Cancel
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>
//       </Dialog>
//       <Box
//         sx={{
//           color: "#333",
//           padding: "20px",
//           fontSize: "20px",
//           fontWeight: 550,
//         }}
//       >
//         <Grid
//           container
//           sx={{
//             display: "flex",
//             justifyContent: "start",
//             alignItems: "center",
//             paddingBottom: "5px",
//           }}
//         >
//           <Grid item xs={12} sm={6} md={5} lg={4}>
//             <Item sx={{ backgroundColor: "#fff", color: "#333" }}>
//               <Typography
//                 gutterBottom
//                 variant="subtitle1"
//                 style={{
//                   fontSize: "18px",
//                   textAlign: "left",
//                   paddingLeft: "20px",
//                 }}
//               >
//                 Total Purchase-
//               </Typography>
//               <Typography
//                 gutterBottom
//                 variant="subtitle1"
//                 style={{
//                   fontSize: "18px",
//                   textAlign: "left",
//                   paddingLeft: "20px",
//                 }}
//               >
//                 Active Membership-
//               </Typography>
//             </Item>
//           </Grid>
//         </Grid>
//         <Box sx={{ color: "#333", bgcolor: "#fff", height: "75vh" }}>
//           <ListItemText style={{ background: "white", margin: 0 }}>
//             <ThemeProvider theme={getTheme()}>
//               <MUIDataTable
//                 title={
//                   <span
//                     style={{
//                       fontWeight: 700,
//                       fontSize: "1.5rem",
//                       color: "#333",
//                     }}
//                   >
//                     Membership Details
//                   </span>
//                 }
//                 // data={detailValue || []}
//                 columns={columns}
//                 options={options}
//               />
//             </ThemeProvider>
//           </ListItemText>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default ViewMoreKnowledge;


import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Chip,
  Divider,
  IconButton,
  Button,
  Stack,
  Paper
} from '@mui/material';
import {
  ArrowBack,
  EditOutlined,
  DeleteOutlined,
  AccessTimeOutlined,
  PhoneOutlined,
  WorkOutlineOutlined,
  PublicOutlined,
  PaletteOutlined
} from '@mui/icons-material';
import StatusAlert from '../../../StatusAlertList/StatusAlert';
import { membershipApis } from '../../../Data/axios';
import { formatDateTimeDDMMYYYY } from '../../../utils/dateUtils';

function ViewMoreMembership() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  
  const [membershipData, setMembershipData] = useState(location?.state?.data || null);
  const [isLoading, setIsLoading] = useState(!location?.state?.data);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  useEffect(() => {
    if (!membershipData) {
      fetchMembershipData();
    }
  }, [id]);

  const fetchMembershipData = async () => {
    setIsLoading(true);
    try {
      const response = await membershipApis.membershipViewMoreId(id);
      if (response && response.data) {
        setMembershipData(response.data);
      } else {
        showAlert('Failed to fetch membership details', 'error');
      }
    } catch (error) {
      console.error('Error fetching membership details:', error);
      showAlert('An error occurred while fetching membership details', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const getUserTypeText = (role) => {
    const roles = {
      '1': 'Driver',
      '2': 'Owner',
      '3': 'Dhaba',
      '4': 'Mechanic',
      '5': 'Crane Owner',
      '6': 'Crane Operator'
    };
    return roles[role] || 'Unknown';
  };

  const getAccessText = (access) => {
    return access === '1' ? 'Location' : access === '2' ? 'Nation Wide' : 'Unknown';
  };

  const handleEdit = () => {
    navigate(`/membership/edit/${id}`, { state: { data: membershipData } });
  };

  const handleBack = () => {
    navigate('/membership');
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Typography>Loading membership details...</Typography>
      </Box>
    );
  }

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      <Box sx={{ p: 3, backgroundColor: "#f5f5f5", minHeight: "calc(100vh - 64px)" }}>
        {/* Header with back button */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box display="flex" alignItems="center">
            {/* <IconButton 
              onClick={handleBack}
              sx={{ mr: 1, bgcolor: 'white',color:'black' }}
            >
              <ArrowBack />
            </IconButton> */}
            <Typography variant="h4" fontWeight="600" color="#212121">
              Membership Details
            </Typography>
          </Box>
          
          <Box>
            <Button 
              variant="outlined" 
              startIcon={<EditOutlined />}
              onClick={handleEdit}
              sx={{ mr: 1, borderColor: "#1d82f5", color: "#1d82f5" }}
            >
              Edit
            </Button>
          </Box>
        </Box>

        <Grid container spacing={3}>
          {/* Main details card */}
          <Grid item xs={12} md={8}>
            <Card 
              elevation={0}
              sx={{ 
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                height: '100%',
                backgroundColor: 'white',
                color: '#212121'
              }}
            >
              <CardContent>
                <Box display="flex" alignItems="center" mb={2}>
                  <Box 
                    sx={{ 
                      width: 50, 
                      height: 50, 
                      backgroundColor: `#${membershipData.color || '364554'}`,
                      borderRadius: 2,
                      mr: 2,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      color: '#ffffff',
                      fontWeight: 'bold',
                      fontSize: '1.2rem'
                    }}
                  >
                    {membershipData.membership?.charAt(0) || 'M'}
                  </Box>
                  <Box>
                    <Typography variant="h5" fontWeight="600" color="#212121">
                      {membershipData.membership} Membership
                    </Typography>
                    <Typography variant="body2" color="#000000">
                      For {getUserTypeText(membershipData.role)}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Stack spacing={3}>
                      <Box>
                        <Typography variant="body1" color="#000000" fontWeight="300" gutterBottom>
                          Pricing Information
                        </Typography>
                        <Box display="flex" alignItems="baseline">
                          <Typography variant="h4" color="#000000" fontWeight="600">
                            ₹{membershipData.price}
                          </Typography>
                          {membershipData.discount && parseInt(membershipData.discount) > 0 && (
                            <Typography variant="body2" color="#000000" ml={1}>
                              (₹{membershipData.discount} discount)
                            </Typography>
                          )}
                        </Box>
                      </Box>
                      
                      <Box>
                        <Typography variant="body1" color="#000000" fontWeight="300" gutterBottom>
                          Access Level
                        </Typography>
                        <Chip 
                          label={getAccessText(membershipData.access)}
                          icon={<PublicOutlined />}
                          variant="outlined" 
                          size="medium"
                          sx={{ bgcolor: '#f9fafb', color: '#424242' }}
                        />
                      </Box>
                    </Stack>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Stack spacing={3}>
                      <Box>
                        <Typography variant="body1" color="#000000" gutterBottom>
                          Validity Period
                        </Typography>
                        <Box display="flex" alignItems="center">
                          <AccessTimeOutlined color="action" sx={{ mr: 1 }} />
                          <Typography variant="body1" color="#212121">
                            {membershipData.validity} days
                          </Typography>
                        </Box>
                      </Box>

                      <Box>
                        <Typography variant="body1" color="#000000" gutterBottom>
                          Status
                        </Typography>
                        <Chip 
                          label={membershipData.status === "1" ? "Active" : "Inactive"}
                          color={membershipData.status === "1" ? "success" : "default"}
                          variant="filled"
                          size="small"
                        />
                      </Box>
                    </Stack>
                  </Grid>
                </Grid>

                <Divider sx={{ my: 2 }} />
                
                <Typography variant="h6" color="#000000" gutterBottom>
                  Membership Benefits
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Paper 
                      elevation={0} 
                      sx={{ 
                        p: 2, 
                        bgcolor: '#f9fafb', 
                        borderRadius: 2, 
                        display: 'flex', 
                        alignItems: 'center',
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      <PhoneOutlined sx={{ color: '#1d82f5', mr: 1 }} />
                      <Box>
                        <Typography variant="body1" color="#000000">
                          Available Calls
                        </Typography>
                        <Typography variant="h6" color="#212121">
                          {membershipData.calls}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Paper 
                      elevation={0} 
                      sx={{ 
                        p: 2, 
                        bgcolor: '#f9fafb', 
                        borderRadius: 2, 
                        display: 'flex', 
                        alignItems: 'center',
                        border: '1px solid #e0e0e0'
                      }}
                    >
                      <WorkOutlineOutlined sx={{ color: '#1d82f5', mr: 1 }} />
                      <Box>
                        <Typography variant="body1" color="#000000">
                          Job Posts
                        </Typography>
                        <Typography variant="h6" color="#212121">
                          {membershipData.jobspost}
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          {/* Side details card */}
          <Grid item xs={12} md={4}>
            <Card 
              elevation={0}
              sx={{ 
                borderRadius: 2,
                border: '1px solid #e0e0e0',
                backgroundColor: 'white',
                color: '#212121'
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight="600" mb={2} color="#212121">
                  Additional Information
                </Typography>
                
                <Box mb={2}>
                  <Typography variant="body1" color="#000000" gutterBottom>
                    Color Code
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Box 
                      sx={{ 
                        width: 24, 
                        height: 24, 
                        backgroundColor: `#${membershipData.color || '364554'}`,
                        borderRadius: 0.5,
                        mr: 1 
                      }} 
                    />
                    <Typography variant="body2" color="#212121">
                      #{membershipData.color || '364554'}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />
                
                <Box mb={2}>
                  <Typography variant="body1" color="#000000" gutterBottom>
                    Created At
                  </Typography>
                  <Typography variant="body2" color="#212121">
                    {formatDateTimeDDMMYYYY(membershipData.created_at)}
                  </Typography>
                </Box>
                
                {membershipData.updated_at && membershipData.updated_at !== membershipData.created_at && (
                  <Box mb={2}>
                    <Typography variant="body1" color="#000000" gutterBottom>
                      Last Updated
                    </Typography>
                    <Typography variant="body2" color="#212121">
                      {formatDateTimeDDMMYYYY(membershipData.updated_at)}
                    </Typography>
                  </Box>
                )}

                <Divider sx={{ my: 2 }} />
                
                <Typography variant="body1" color="#000000" mb={1}>
                  Membership ID
                </Typography>
                <Paper
                  elevation={0}
                  sx={{
                    p: 1.5,
                    bgcolor: '#f9fafb',
                    borderRadius: 1,
                    textAlign: 'center',
                    border: '1px solid #e0e0e0'
                  }}
                >
                  <Typography variant="body2" fontFamily="monospace" color="#212121">
                    {membershipData.id}
                  </Typography>
                </Paper>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default ViewMoreMembership;